// extracted by mini-css-extract-plugin
export default {"traits":"Traits-module__traits__S3zZv","header":"Traits-module__header__vuIcF","title":"Traits-module__title__wDXWE"};